import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'svg'];

  connect() {
    this.svgTarget.addEventListener('click', (event) => {
      if (typeof this.inputTarget.showPicker === 'function') {
        this.inputTarget.showPicker();
      }
    });
  }
}
